module.exports = __webpack_public_path__ + "static/media/cc_icon-disc.db2d71e3.svg";